import fs from 'node:fs'
import type { ResolvedBetterstartConfig } from '@cli-types/core-engine/config.js'
import { getEmailTemplatesDir } from './get-email-templates-dir.js'

export function ensureEmailTemplatesDir(cwd: string, config: ResolvedBetterstartConfig): void {
  fs.mkdirSync(getEmailTemplatesDir(cwd, config), { recursive: true })
}
